"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var react_router_dom_1 = require("react-router-dom");
var queryString = require("query-string");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var diaryEntriesActions = require("@caddigital/sok-reducers/lib/actions/diaryentries/list");
var DiaryentriesReducer = require("@caddigital/sok-reducers/lib/reducers/diaryentries/list");
var diaryActions = require("@caddigital/sok-reducers/lib/actions/sokosite/current");
var translate_1 = require("utils/translate");
var search_1 = require("utils/search");
var Types = require("types");
require("./style.scss");
var Tools_1 = require("./Tools");
var ListContainer_1 = require("./ListContainer");
var ToolsSideBar_1 = require("./ToolsSideBar");
var mapStateToProps = function (state, ownProps) {
    return {
        currentWorksiteDiary: state.sokosite.current.worksiteDiary,
        diaryEntries: state.diaryentries.list
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    fetchCurrentDiary: function (diaryUuid) {
        return dispatch(diaryActions.fetchRequest(diaryUuid));
    },
    fetchDiaryEntries: function (diaryUuid) {
        return dispatch(diaryEntriesActions.fetchRequest(diaryUuid));
    }
}); };
var statePropsExtractable = Types.extractReturnType(mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(mapDispatchToProps);
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), (0, recompose_1.withState)('queryParams', 'setQueryParams', {}), react_router_dom_1.withRouter, (0, recompose_1.lifecycle)({
    componentWillMount: function () {
        this.props.fetchCurrentDiary(this.props.match.params.id);
        this.props.fetchDiaryEntries(this.props.match.params.id);
        var params = queryString.parse(this.props.location.search);
        var keys = Object.keys(params).sort(function (a, b) { return a.localeCompare(b); });
        // Decode params
        for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
            var key = keys_1[_i];
            params[key] = decodeURIComponent(params[key]);
        }
        var url = this.props.location.pathname +
            (0, search_1.getQueryParams)(__assign(__assign({}, DiaryentriesReducer.defaultOrderByOptions), params));
        this.props.history.replace(url);
        this.props.setQueryParams(params);
        // this.props.dispatch(diaryEntriesActions.setInitData(params))
    },
    componentWillReceiveProps: function (nextProps) {
        if (this.props.location.search !== nextProps.location.search) {
            var params = queryString.parse(nextProps.location.search);
            var keys = Object.keys(params).sort(function (a, b) { return a.localeCompare(b); });
            // Decode params
            for (var _i = 0, keys_2 = keys; _i < keys_2.length; _i++) {
                var key = keys_2[_i];
                params[key] = decodeURIComponent(params[key]);
            }
            this.props.setQueryParams(params);
            // this.props.dispatch(diaryEntriesActions.setInitData(params))
        }
    },
    shouldComponentUpdate: function (nextProps) {
        if (this.props.currentProject !== nextProps.currentProject ||
            this.props.currentWorksiteDiary !== nextProps.currentWorksiteDiary ||
            this.props.diaryEntries !== nextProps.diaryEntries ||
            this.props.queryParams !== nextProps.queryParams ||
            this.props.diaryEntries.selected !== nextProps.diaryEntries.selected) {
            return true;
        }
        return false;
    }
}), recompose_1.pure);
exports.default = enhance(function (props) {
    var selectedLanguage = (0, translate_1.getLanguage)();
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'content-wrapper-content' },
            React.createElement("div", { className: 'diaryentries-list-view' },
                React.createElement("main", { className: 'content' },
                    React.createElement(sok_ui_1.BreadCrumb, null,
                        props.currentProject ? (React.createElement(react_router_dom_1.Link, { to: "/".concat(selectedLanguage, "/projects/").concat(props.currentProject.id) }, props.currentProject.name)) : (React.createElement(react_router_dom_1.Link, { to: "/".concat(selectedLanguage) }, "SokoPro")),
                        props.currentProject && (React.createElement(react_router_dom_1.Link, { to: "/".concat(selectedLanguage, "/projects/").concat(props.currentProject.id, "/sokosite") }, (0, translation_1.getLocalization)('breadcrumb/sokosite'))),
                        props.currentProject &&
                            props.currentWorksiteDiary &&
                            props.currentWorksiteDiary.name && (React.createElement(react_router_dom_1.Link, { to: "/".concat(selectedLanguage, "/projects/").concat(props.currentProject.id, "/sokosite/worksitediary/").concat(props.currentWorksiteDiary.diary_uuid) }, "".concat((0, translation_1.getLocalization)('breadcrumb/worksiteDiary'), ": ").concat(props.currentWorksiteDiary.name),
                            props.currentWorksiteDiary.site_number
                                ? " - ".concat(props.currentWorksiteDiary.site_number)
                                : '')),
                        React.createElement("span", null, (0, translation_1.getLocalization)('diaryEntriesView/entries'))),
                    React.createElement(Tools_1.Tools, { currentProject: props.currentProject, currentWorksiteDiary: props.currentWorksiteDiary, queryParams: props.queryParams, pathname: props.location.pathname, updateUrl: props.history.push }),
                    React.createElement(ListContainer_1.ListContainer, { currentProject: props.currentProject, currentWorksiteDiary: props.currentWorksiteDiary, diaryEntries: props.diaryEntries.list, queryParams: props.queryParams, pathname: props.location.pathname, updateUrl: props.history.push })))),
        React.createElement(ToolsSideBar_1.Tools, __assign({ currentProject: props.currentProject, updateUrl: props.history.push, selected: props.diaryEntries.selected }, props))));
});
